import * as e from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Medal.es.js";
const o = e.forwardRef((a, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...a, weights: m }));
o.displayName = "MedalIcon";
const n = o;
export {
  n as Medal,
  o as MedalIcon
};
